/**
 * @prettier
 */

import React from 'react';

import cx from 'classnames';
import styles from './styles.module.less';

export const ToggleLabel = ({ className = '' }) => {
  return <div className={cx(styles.toggleLabelBox, className)}>Pick free samples</div>;
};

export default ToggleLabel;
